import { c as _c } from "react/compiler-runtime";
import { ProjectActions } from "@components/common/project-actions";
import { RemoveMemberMenuItem } from "@components/table/member-group-projects/remove-member-menu-item";
import { DeleteIcon } from "@flat-ui";
import { useHasUserValidPermissionProjectLevel } from "@hooks/permission-control/use-has-user-valid-permission-project-level";
import { getProjectByIdSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { isProjectAssignedThroughTeam } from "@utils/data-display";
/**
 * Project actions for the member overview page: the shared project actions plus
 * a "Remove member" option. The option is hidden when the current user lacks the
 * permission to remove members from the project, and disabled when the member's
 * access is inherited through a team or the member is the project's resource owner.
 */
export function MemberGroupProjectActions(t0) {
  const $ = _c(17);
  const {
    project,
    member,
    onMemberRemoved
  } = t0;
  let t1;
  if ($[0] !== project.id) {
    t1 = getProjectByIdSelector(project.id);
    $[0] = project.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sdbProject = useAppSelector(t1);
  let t2;
  if ($[2] !== sdbProject) {
    t2 = {
      project: sdbProject
    };
    $[2] = sdbProject;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    canDeleteMemberFromProject
  } = useHasUserValidPermissionProjectLevel(t2);
  let t3;
  if ($[4] !== project) {
    t3 = isProjectAssignedThroughTeam(project);
    $[4] = project;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const isAssignedThroughTeam = t3;
  const isResourceOwner = project.role === "RESOURCE_OWNER";
  const canRemoveMember = sdbProject !== null && sdbProject.archivingState !== "ARCHIVED" && canDeleteMemberFromProject;
  let t4;
  if ($[6] !== isAssignedThroughTeam || $[7] !== isResourceOwner || $[8] !== member || $[9] !== onMemberRemoved) {
    t4 = {
      label: "Remove member",
      Icon: DeleteIcon,
      component: (item, closeMenu) => <RemoveMemberMenuItem project={item} member={member} isAssignedThroughTeam={isAssignedThroughTeam} isResourceOwner={isResourceOwner} onRemoved={onMemberRemoved} closeMenu={closeMenu} />
    };
    $[6] = isAssignedThroughTeam;
    $[7] = isResourceOwner;
    $[8] = member;
    $[9] = onMemberRemoved;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const removeMemberItem = t4;
  let t5;
  if ($[11] !== canRemoveMember || $[12] !== removeMemberItem) {
    t5 = canRemoveMember ? [removeMemberItem] : [];
    $[11] = canRemoveMember;
    $[12] = removeMemberItem;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== project || $[15] !== t5) {
    t6 = <ProjectActions project={project} contextType="member-group-project-list-view" extraMenuItems={t5} />;
    $[14] = project;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}